<template>
    <div class="link-list">
        <div v-if="module !== '0'">
            <h3 class="module-header">
                {{ createHeader(module) }}
            </h3>
            <Block
                v-for="(links, title) in getModuleLinks(module)"
                :key="title"
                :title="title"
                :links="links"
            />
        </div>
        <div v-else>
            <h3>
                Nützliche Websites für weiterführende Informationen
            </h3>
            <div
                v-for="(moduleList, moduleKey) in list"
                :key="moduleKey"
                class="module-links"
            >
                <h4 class="module-header">
                    {{ createHeader(moduleKey) }}<br>
                    <span class="subtitle xx-small-size">
                        {{ getModuleConfig(moduleKey).title }}
                    </span>
                </h4>
                <Block
                    v-for="(links, title) in getModuleLinks(moduleKey)"
                    :key="title"
                    :title="title"
                    :links="links"
                />
            </div>
        </div>
        <ControlButton
            :active="true"
            @click="$router.go(-1)"
        >
            Zurück
        </ControlButton>
    </div>
</template>

<script>
import list from '@/static/linkList.json';
import modules from '@/static/modules.json';
import Block from '@/components/views/LinkList/Block';

export default {
    name: 'Personas',
    components: {
        Block
    },
    props: {
        module: {
            type: String,
            required: true
        }
    },
    data: () => ({
        list
    }),
    watch: {
        module()
        {
            this.changeHeader();
        }
    },
    mounted()
    {
        this.changeHeader();
    },
    methods: {
        changeHeader()
        {
            const config = this.getModuleConfig(this.module);
            let subtitle = 'Sammelkiste';
            if (this.module !== '0')
            {
                subtitle += ` Lerneinheit ${this.module}`;
            }
            this.$root.resetHeader(subtitle, config.mainTitle);
        },
        getModuleLinks(module)
        {
            return list[module];
        },
        getModuleConfig(module)
        {
            return modules[module];
        },
        createHeader(module)
        {
            return `Alle Links der Lerneinheit ${module} auf einen Blick`;
        }
    }
};
</script>

<style lang="scss" src="./LinkList.scss" />
